import { render, staticRenderFns } from "./PD.vue?vue&type=template&id=ddcb2ce0&scoped=true"
import script from "./PD.vue?vue&type=script&lang=js"
export * from "./PD.vue?vue&type=script&lang=js"
import style0 from "./PD.vue?vue&type=style&index=0&id=ddcb2ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcb2ce0",
  null
  
)

export default component.exports